const getFirstName = <T extends { firstName?: string }>(param: T): string =>
  param.firstName ?? '';

const getLastName = <T extends { lastName?: string }>(param: T): string =>
  param.lastName ?? '';

export const getFullName = <
  T extends { firstName?: string; lastName?: string },
>(
  person: T,
) => `${getFirstName(person)} ${getLastName(person)}`;
